import { render, staticRenderFns } from "./dkjjimg.vue?vue&type=template&id=502f6dc1&scoped=true&"
import script from "./dkjjimg.vue?vue&type=script&lang=js&"
export * from "./dkjjimg.vue?vue&type=script&lang=js&"
import style0 from "./dkjjimg.vue?vue&type=style&index=0&id=502f6dc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502f6dc1",
  null
  
)

export default component.exports